$(document).on("turbo:load", initTooltips);
function initTooltips() {
  $('[data-toggle="tooltip"]').tooltip({});
}
